import { render, staticRenderFns } from "./ActivityWidget.vue?vue&type=template&id=b7493184&scoped=true&"
import script from "./ActivityWidget.vue?vue&type=script&lang=js&"
export * from "./ActivityWidget.vue?vue&type=script&lang=js&"
import style0 from "./ActivityWidget.vue?vue&type=style&index=0&id=b7493184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7493184",
  null
  
)

export default component.exports